import { Checkbox } from "antd";

export const OUTPUT_FORMATS = ["PNG", "JPG", "PDF", "TIFF", "EMB", "DST"];

// outputFormat is stored as a comma-separated string, e.g. "PNG,PDF"
export const parseOutputFormats = (value) =>
  String(value || "")
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);

export default function OutputFormatPicker({ value, onChange }) {
  const selected = parseOutputFormats(value);
  const legacy = selected.filter((item) => !OUTPUT_FORMATS.includes(item));
  return (
    <Checkbox.Group
      className="specstudio-format-picker"
      value={selected}
      options={OUTPUT_FORMATS.map((format) => ({
        value: format,
        label: format,
      }))}
      onChange={(next) => {
        const ordered = [
          ...OUTPUT_FORMATS.filter((format) => next.includes(format)),
          ...legacy,
        ];
        onChange?.(ordered.length ? ordered.join(",") : null);
      }}
    />
  );
}
